import React from 'react';
import style from './style.scss'
import newId from '../../utils/newid';

const RenderButton = (props) => {
    const {item, field} = props;
    const id = newId();
    return (
        <div className="">
            <button
                onClick={(t) => {
                    return props.onClick()
                }}
            >
                {(typeof item.label === 'string') ? item.label : item.label.first}
            </button>
        </div>

    )
}

export default RenderButton;
